"use client";

import { useEffect, useRef, type ReactNode } from "react";

// Handwriting for the workshop tag: the letters (.wz-ink, data-at = start in ms) are switched on by time. One
// timer loop flips a class on a few spans per frame; ~200 CSS animations at once stuttered scrolling during the write-in.
export default function WriteIn({ children }: { children: ReactNode }) {
  const ref = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const el = ref.current;
    if (!el) return;
    const spans = [...el.querySelectorAll<HTMLElement>(".wz-ink")];
    if (matchMedia("(prefers-reduced-motion: reduce)").matches) {
      el.classList.add("wz-done");
      return;
    }
    let i = 0;
    let raf = 0;
    const t0 = performance.now();
    const tick = (now: number) => {
      while (i < spans.length && Number(spans[i].dataset.at) <= now - t0) spans[i++].classList.add("on");
      if (i < spans.length) raf = requestAnimationFrame(tick);
      else el.classList.add("wz-done");
    };
    raf = requestAnimationFrame(tick);
    return () => cancelAnimationFrame(raf);
  }, []);
  return (
    <div ref={ref} className="wz-write contents">
      {children}
    </div>
  );
}
